import isNaN from "lodash/isNaN";
import isNil from "lodash/isNil";

import Text from "@/ui/core/Text";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface CounterProps extends BaseViewProps {
  isActive?: boolean;
  number?: number;
}

const Counter = ({
  accessibilityLabel,
  isActive,
  number,
  testID,
}: CounterProps) => {
  if (isNaN(number) || isNil(number) || number <= 0) {
    return null;
  }

  const numberValue = number.toLocaleString();
  const textColor = isActive
    ? ColorToken.NeutralBackgroundPrimary
    : ColorToken.AccentBlue;
  const bgColor = isActive ? ColorToken.AccentBlue : ColorToken.Secondary10;

  return (
    <Box
      alignItems="center"
      aria-label={accessibilityLabel}
      backgroundColor={bgColor}
      borderRadius={18}
      height={18}
      justifyContent="center"
      minWidth={18}
      paddingHorizontal={4}
      paddingVertical={0}
    >
      <Text
        color={textColor}
        testID={joinTestIDs(testID, "counter")}
        variant="caption"
      >
        {numberValue}
      </Text>
    </Box>
  );
};

export type { CounterProps };
export default Counter;
